import SmallSquareButton from 'components/common/SmallSquareButton'
import theme from 'theme'
import { ScheduleDay } from 'types/schedules/default'
import { WEEK_DAYS, toThreeLetterWeekDay } from 'utils/days'

type DayPickerProps = {
  activeDays: ScheduleDay[]
  onChange?(day: ScheduleDay): void
  buttonSize?: number
  isStatic?: boolean
  disabled?: boolean
}

const DayPicker: React.FC<DayPickerProps> = ({
  activeDays = [],
  onChange,
  buttonSize = theme.space[5],
  isStatic,
  disabled
}) => {
  return (
    <div
      css={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: `repeat(auto-fill, ${buttonSize}px)`,
        gap: theme.space[1]
      }}
    >
      {WEEK_DAYS.map((day) => {
        return (
          <SmallSquareButton
            key={day}
            css={{ height: buttonSize, width: buttonSize }}
            data-test-daypicker-day={day}
            data-test-daypicker-is-selected={activeDays.indexOf(day) > -1}
            disabled={disabled}
            isSelected={activeDays.indexOf(day) > -1}
            isStatic={isStatic}
            onClick={(event) => {
              if (onChange) {
                event.stopPropagation()
                onChange(day)
              }
            }}
          >
            {toThreeLetterWeekDay(day)}
          </SmallSquareButton>
        )
      })}
    </div>
  )
}

export default DayPicker
